import { useEffect } from 'react';
import { findDOMNode } from 'react-dom';
/*
  This hook is used to disable text selection on a div element
*/
export const nonSelectableElementHook = (ref) => {
    useEffect(() => {
        if (ref.current) {
            // add style to iframe wrapper
            const divWrapper = findDOMNode(ref.current);
            divWrapper.style.userSelect = 'none';
            divWrapper.style.webkitUserSelect = 'none';
        }
    }, []);
};
//# sourceMappingURL=css.js.map